import { useNavigationType } from "react-router-dom";
export const useIsHistoryPop = () => {
  const navType = useNavigationType();

  return navType === "POP";
};
